import { render } from "./DelivEmailList.vue?vue&type=template&id=f2d3fe1c&scoped=true"
import script from "./DelivEmailList.vue?vue&type=script&lang=js"
export * from "./DelivEmailList.vue?vue&type=script&lang=js"

import "./DelivEmailList.vue?vue&type=style&index=0&id=f2d3fe1c&scoped=true&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2d3fe1c"]])

export default __exports__